import { render } from "./BookingHoursSelector.vue?vue&type=template&id=61859254"
import script from "./BookingHoursSelector.vue?vue&type=script&lang=js"
export * from "./BookingHoursSelector.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__